import { Skeleton } from '@agro1desenvolvimento/react-components';
import { times } from 'lodash';
import { PropriedadeCard } from './propriedade-card';

const CARDS_SKELETON_COUNT = 8;

const CardsSkeleton = () => (
  <>
    {times(CARDS_SKELETON_COUNT, (index) => (
      <PropriedadeCard
        key={index}
        title={<Skeleton width="70%" />}
        footer={<Skeleton width="40%" />}
      >
        <Skeleton height="150px" className="disabled-shimmer" />
      </PropriedadeCard>
    ))}
  </>
);

export default CardsSkeleton;
